import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import {
  ActivatedRoute,
  NavigationEnd,
  PRIMARY_OUTLET,
  Router,
  RouterModule
} from '@angular/router';
import { filter, map } from 'rxjs';
import { FeatherIconsComponent } from '../feather-icons/feather-icons.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-breadcrumb',
  imports: [CommonModule, RouterModule, FeatherIconsComponent],
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent {
  public breadcrumbs: { parentBreadcrumb?: string; childBreadcrumb?: string; enable?: boolean };
  public title: string = '';

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private translateService: TranslateService
  ) {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .pipe(map(() => this.activatedRoute))
      .pipe(
        map((route) => {
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        })
      )
      .pipe(filter((route) => route.outlet === PRIMARY_OUTLET))
      .subscribe((route) => {
        let snapshot = this.router.routerState.snapshot;
        let title = this.translateService.instant(route.snapshot.data['title']);
        let parent = route.parent?.snapshot.data['breadcrumb'];
        if (parent) {
          parent = this.translateService.instant(parent);
        }
        let isEnable = route.parent?.snapshot.data['isEnable'];
        let child = this.translateService.instant(route.snapshot.data['breadcrumb']);
        this.breadcrumbs = {};
        this.title = title;
        this.breadcrumbs = {
          parentBreadcrumb: parent,
          childBreadcrumb: child,
          enable: isEnable
        };
      });
  }
}
